import EventBlockObject from "./BlockObjects/EventBlockObject";
import GroupBlockObject from "./BlockObjects/GroupBlockObject";
import FacebookBlockObject from "./BlockObjects/FacebookBlockObject";
import HtmlBlockObject from "./BlockObjects/HTMLBlockObject";
import InstagramBlockObject from "./BlockObjects/InstagramBlockObject";
import MessageBlockObject from "./BlockObjects/MessageBlockObject";
import NewsBlockObject from "./BlockObjects/NewsBlockObject";
import OrganizationBlockObject from "./BlockObjects/OrganizationBlockObject";
import PageBlockObject from "./BlockObjects/PageBlockObject";
import PersonBlockObject from "./BlockObjects/PersonBlockObject";
import PinterestBlockObject from "./BlockObjects/PinterestBlockObject";
import PollBlockObject from "./BlockObjects/PollBlockObject";
import QuickLinkBlockObject from "./BlockObjects/QuickLinkBlockObject";
import ReuseBlockObject from "./BlockObjects/ReuseBlockObject";
import SchoolFeedFullPageBlockObject from "./BlockObjects/SchoolFeedFullPageBlockObject";
import SharedFilesBlockObject from "./BlockObjects/SharedFilesBlockObject";
import StaffBlockObject from "./BlockObjects/StaffBlockObject";
import TwitterBlockObject from "./BlockObjects/TwitterBlockObject";
import WeatherBlockObject from "./BlockObjects/WeatherBlockObject";
import VideoBlockObject from "./BlockObjects/VideoBlock/VideoBlockObject";
import GenericBlockObject from "./BlockObjects/GenericBlockObject";

export function blockObjectFactory(blockType: IBlockType, initialProps?: AnyBlockObj): IBlockObj | IPersonBlock {
    switch (blockType) {
        case "eventlist": return new EventBlockObject(blockType, initialProps as IEventBlockObj);
        case "group":
        case "department":
        case "section":
        case "team":
            return new GroupBlockObject(blockType, initialProps as IGroupBlockObj);
        case "facebook": return new FacebookBlockObject(blockType, initialProps as IFacebookBlockObj);
        case "html": return new HtmlBlockObject(blockType, initialProps as IHtmlBlockObj);
        case "instagram": return new InstagramBlockObject(blockType, initialProps as IInstagramBlockObj);
        case "message": return new MessageBlockObject(blockType, initialProps as IMessageBlockObj);
        case "news": return new NewsBlockObject(blockType, initialProps as INewsBlockObj);
        case "school":
        case "district":
        case "organization":
        case "classroom":
            return new OrganizationBlockObject(blockType, initialProps as IBlockObj);
        case "page": return new PageBlockObject(blockType, initialProps as IPageBlockObj);
        case "person": return new PersonBlockObject(blockType, initialProps as IPersonBlock);
        case "pinterest": return new PinterestBlockObject(blockType, initialProps as IPinterestBlockObj);
        case "poll": return new PollBlockObject(blockType, initialProps as IPollBlockObj);
        case "quicklink": return new QuickLinkBlockObject(blockType, initialProps as IQuicklinkBlockObj);
        case "reuse": return new ReuseBlockObject(blockType, initialProps as IReuseBlockObj);
        case "content_item": return new SchoolFeedFullPageBlockObject(blockType, initialProps as IBlockObj);
        case "sharedfiles": return new SharedFilesBlockObject(blockType, initialProps as ISharedFilesBlockObj);
        case "staff": return new StaffBlockObject(blockType, initialProps as IStaffBlockObj);
        case "twitter": return new TwitterBlockObject(blockType, initialProps as ITwitterBlockObj);
        case "weather": return new WeatherBlockObject(blockType, initialProps as IWeatherBlockObj);
        case "youtube":
        case "video": return new VideoBlockObject(blockType, initialProps as IVideoBlockObj);
        default:
            return new GenericBlockObject(blockType, initialProps as IBlockObj);
    }
}
